import { z } from "zod";

export const userSignInSchema = z.object({
	email: z.email(),
	password: z.string({ error: "Bitte Passwort angeben" }).min(8),
	rememberMe: z.any().default(false).pipe(z.boolean()).optional(),
});

export type SignInSchema = z.infer<typeof userSignInSchema>;
